import React from 'react';
import CareerQuizEngine from './CareerQuizEngine';

const CareerSurvey = () => {
    return (
        <CareerQuizEngine />
    );
};

export default CareerSurvey;
